<template lang="pug">
    .app_popup
        .contentWrapper
            .content
                transition(name="fade" mode="out-in")
                    div(v-if="!success" key="1")
                        .popup_title {{$t('subscribePopup.allEventsSubscribed')}}
                        form(@submit.prevent="submit")
                            .app_input
                                input(:placeholder="$t('subscribePopup.enterEmail')" v-model="email")
                                .app_error(v-if="$v.$dirty && !$v.email.required") Поле обязательно для заполнения
                                .app_error(v-else-if="$v.$dirty && !$v.email.email") Некорректный email адрес
                                .app_error(v-else-if="commonError") {{commonError}}
                            button.app_btn.light_blue(type="submit") {{$t('other.subscribe')}}
                            .app_checkbox(:class="{error: $v.$dirty && !$v.pdnAgree.agree}")
                                input#pdnAgree(type="checkbox" v-model="pdnAgree")
                                label(for="pdnAgree")
                                    .square(:class="{active:pdnAgree}")
                                    span
                                        i18n(path="subscribePopup.pdnAgree")
                                            a(href="" place="link") {{$t('subscribePopup.pdnAgreeLink')}}
                    .successMessage(v-else key="2")
                        .popup_title {{$t('subscribePopup.allEventsSubscribed')}}
                        //.popup_text Подписка на обновления/ событие/ XX-е мартобря успешно оформлена.
                        .popup_text {{$t('subscribePopup.subscribedSuccess')}} {{type==='all'?$t('subscribePopup.allEvents') : type==='day'?$t('subscribePopup.events')+' '+name : type==='event'?$t('subscribePopup.event') : type==='tag'?$t('subscribePopup.tags') : ''}}.
                        .app_btn.light_blue(@click="$store.commit('closePopup')") ОК


            app-closer(@click.native="$store.commit('closePopup')")
</template>

<script>
    import {required, email} from 'vuelidate/lib/validators'

    export default {
        name: "SendMessagePopup",
        data: () => ({
            email: '',
            pdnAgree: false,

            success: false,
            commonError: '',
        }),
        computed:{
            type(){
                return this.$store.state.popupContent.type;
            },
            code(){
                return this.$store.state.popupContent.code;
            },
            name(){
                return this.$store.state.popupContent.name;
            },
            tags(){
                return this.$store.state.popupContent.tags;
            }
        },
        validations:{
            email: {required, email},
            pdnAgree: {agree(value){return value}}
        },
        methods: {
            async submit(){
                this.commonError = '';
                if (this.$v.$invalid) {
                    this.$v.$touch()
                    return
                }
                try {
                    let url = `?ACTION=addSubscribe&EMAIL=${this.email}&TYPE=${this.type}`;

                    if(this.type === 'day' || this.type === 'event'){
                        url+=`&CODE=${this.code}`;
                    } else if (this.type === 'tag' && this.tags){
                        this.tags.forEach(tag=>{
                            url+=`&CODE[]=${tag}`
                        })
                    }

                    let {data} = await this.axios.get(url);
                    this.$cookie.set('userSubscribeEmail', this.email);
                    if (data.STATUS === 'ok') {
                        this.success = true;
                    }else{
                        if (data.MESSAGE){
                            this.commonError = data.MESSAGE;
                        }
                    }
                } catch (e) {
                    console.log(e);
                }
            }
        },
    }
</script>

<style scoped lang="scss">
    @import "../../assets/scss/_popup.scss";
    .popup_title{
        margin-bottom: 2.65rem;
    }
    form{
        display: flex;
        flex-direction: column;
        align-items: center;
        max-width: 20rem;
        margin: 0 auto;
        .app_input, .app_btn{
            width: 100%;
        }
        .app_input{
            margin-bottom: 2.5rem;
        }
        .app_btn{
            margin-bottom: 2.55rem;
        }
        .app_checkbox{
            width: 110%;
            margin-left: 7%;
        }
    }
    .app_btn{
        justify-content: center;
        padding: 0.3rem 1.9rem 0.2rem;
        font-size: 1.5rem;
    }
    .successMessage{
        display: flex;
        flex-direction: column;
        align-items: center;
        .popup_text{
            margin-bottom: 3rem;
        }
        .app_btn{
            width: 100%;
            max-width: 20rem;
        }
    }
    @include mobile_or_P{
        form{
            max-width: 21.5rem;
            .app_input{
                margin-bottom: 1.3rem;
            }
            .app_btn{
                margin-bottom: 1.55rem;
            }
        }
        .popup_title{
            margin-bottom: 1.7rem;
        }
    }
</style>
